import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArchive, faBurn } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BLink } from "bootstrap-vue";
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { useHistoryStore } from "@/stores/historyStore";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SwitchToHistoryLink',
    props: {
        historyId: null,
        filters: null
    },
    setup(__props) {
        const props = __props;
        library.add(faArchive, faBurn);
        const router = useRouter();
        const historyStore = useHistoryStore();
        const history = computed(() => historyStore.getHistoryById(props.historyId));
        const canSwitch = computed(() => !!history.value && !history.value.archived && !history.value.purged);
        const actionText = computed(() => {
            if (canSwitch.value) {
                if (props.filters) {
                    return "Show in history";
                }
                return "Switch to";
            }
            return "View in new tab";
        });
        function onClick(history) {
            if (canSwitch.value) {
                if (props.filters) {
                    historyStore.applyFilters(history.id, props.filters);
                }
                else {
                    historyStore.setCurrentHistory(history.id);
                }
                return;
            }
            viewHistoryInNewTab(history);
        }
        function viewHistoryInNewTab(history) {
            const routeData = router.resolve(`/histories/view?id=${history.id}`);
            window.open(routeData.href, "_blank");
        }
        return { __sfc: true, router, historyStore, props, history, canSwitch, actionText, onClick, viewHistoryInNewTab, faArchive, faBurn, FontAwesomeIcon, BLink, LoadingSpan };
    }
});
